import { getUuid } from '@sibe/utilities/common';
import { HsGeometryType } from '../../graphic-engine-new/geometry/geometry-type.enum';
import { HsRegularGeometry } from '../../graphic-engine-new/geometry/regular-geometry.class';
import type { HsGraphicsBuffer } from '../../graphic-render-new/types/graphic-buffer.type';
import type { HsGraphics } from '../../graphic-render-new/graphics.class';
import { HsBox } from '../../math-new/shapes/box.class';
import { HsSphere } from '../../math-new/shapes/sphere.class';
import type { HsRegularGeometryData } from './regular-geometry-data.class';

/**
 * Handles s make geometry.
 */
export function hsMakeGeometry(graphics: HsGraphics, mesh: HsRegularGeometryData): HsRegularGeometry | null {
  const vertices: Float32Array =
    mesh.vertices instanceof Float32Array ? mesh.vertices : Float32Array.from(mesh.vertices);
  const normals: Float32Array = mesh.normals instanceof Float32Array ? mesh.normals : Float32Array.from(mesh.normals);
  const box: HsBox = HsBox.makeFromArray(vertices);
  const sphere: HsSphere = HsSphere.makeSphereFromBoundingBox(box.min, box.max);
  const bufferArray: Float32Array = new Float32Array(vertices.length + normals.length);
  bufferArray.set(vertices);
  bufferArray.set(normals, vertices.length);
  const buffer: HsGraphicsBuffer | null = graphics.createBuffer(bufferArray);
  if (buffer === null) {
    return null;
  }
  const geometry: HsRegularGeometry = new HsRegularGeometry(
    getUuid(),
    HsGeometryType.Triangles,
    box,
    sphere,
    vertices.length,
    normals.length,
    buffer
  );
  return geometry;
}
